import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import { OrderListAction } from '../../enums/OrderListAction';
import { AppComponent } from '../../app.component';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { CheckoutModalComponent } from '../checkout-modal/checkout-modal.component';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import { MenuPage } from '../../pages/menu/menu.page';
import Order from '../../../smoothr-web-app-core/models/Order';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import { isAvailable, maxFskOfOrder, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { NoteArticleModalComponent } from '../note-article-modal/note-article-modal.component';
import { NavigationService } from 'src/app/services/navigation.service';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { ModalInfoHalfPizzaComponent } from '../modal-info-half-pizza/modal-info-half-pizza.component';
import { environment } from 'src/environments/environment';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { InformationModalComponent } from '../information-modal/information-modal.component';
import { InfoModalComponent } from '../info-modal/info-modal.component';

@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss'],
})
export class OrderContentComponent extends RepositoryInterface implements OnInit {
	moment = moment;

	isValid = false;
	loading = false;

	ou = OrderUtils;
	pt = PreorderType;
	differenceToMvo: number;
	@Input()
	fromMenu = false;
	promoError: string;
	tip = 0;
	totalPriceValue = '';
	showAgeVefiried: boolean = false;
	ageVerified: boolean = false;
	totalNumber: number = 0;
	numberToCurrency = numberToCurrency;
	@Output() openCheckout = new EventEmitter<void>();
	private customPromoCodeFor3Pizza = 'PICKUP4FOR3';
	public customPromoCodeRemoved = false;
	private customPromoCodeValue: PromoCode = null;
	private showCheckerDialog = false;
	constructor(
		public translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService,
		private navigationService: NavigationService
	) {
		super(repository);
		this.validate();
	}

	get hasArticles(): boolean {
		return !!this.order && this.order.orderedArticles.length > 0;
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.openOrderContent();
		if (this.order && !this.order?.promoCode) {
			this.loadPromoCode();
		}
	}

	onVenue() {
		super.onVenue();
		this.validate();
		this.totalPrice();
	}

	onOrder() {
		super.onOrder();
		console.log('ORDER CHANGED', this.order, this.venue);
		if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
			this.analytics.orderHasProducts();
		}
		this.validate();
		if (this.order) {
			this.totalPrice();
		}
		if (this.order && !this.order?.promoCode && !this.customPromoCodeRemoved) {
			this.checkIfCanApplyPromoCode(this.order);
		}
	}
	private async loadPromoCode() {
		try {
			const result = (
				await Api.getPromoCode({
					code: this.customPromoCodeFor3Pizza,
					venue: this.order.venue,
					customer: this.customer?._id,
				})
			)?.data as PromoCode;
			if (result && result?.active) {
				this.customPromoCodeValue = result;
			}
		} catch (e) {
			console.log('Error while loading PromoCode');
		}
	}
	async onAction(index: number, event: OrderListAction) {
		switch (event) {
			case OrderListAction.add:
				this.order.orderedArticles[index].quantity += 1;
				break;
			case OrderListAction.delete:
				if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
					const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
					const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
					const matchingBogoArticleIndices = this.order.orderedArticles
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
									OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translate.instant('remove_bogo_alert.header'),
								message: this.translate.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translate.instant('remove_bogo_alert.button_remove'),
										handler: () => {
											this.order.orderedArticles[bogoArticleIndex].isPromo = false;
											this.order.promoCode = null;
											this.order.orderedArticles.splice(index, 1);
											bogoAlert.dismiss();
										},
									},
									{
										text: this.translate.instant('remove_bogo_alert.button_keep'),
										handler: () => {
											bogoAlert.dismiss();
										},
									},
								],
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}
				this.order.orderedArticles.splice(index, 1);
				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
					component: this.checkPageIfHaveGrid(JSON.parse(JSON.stringify(this.order.orderedArticles[index])))
						? ModalInfoHalfPizzaComponent
						: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
						recommend: false,
					},
					showBackdrop: true,
					backdropDismiss: true,
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = this.order.orderedArticles.findIndex(oa => oa.isPromo);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						this.order.orderedArticles[index].article._id === this.order.orderedArticles[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
							OrderUtils.bogoPrice(this.order.orderedArticles[promoAgIndex], this.order.type, this.order.preorder.type)
					) {
						this.order.orderedArticles[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
						newPromoAg.isPromo = true;
						this.order.orderedArticles.push(newPromoAg);
					}
					this.order.orderedArticles[index] = response.data.articleGroup;
					this.repository.onOrderChange(this.order);
				}
				break;
			case OrderListAction.remove:
				if (this.order.orderedArticles[index].quantity > 1) {
					this.order.orderedArticles[index].quantity -= 1;
				} else {
					await this.onAction(index, OrderListAction.delete);
					return;
				}
				break;
		}
		this.checkPromoCodeIsExist(this.order);
		this.repository.onOrderChange(this.order);
	}

	private checkPromoCodeIsExist(order: Order): Order {
		if (order?.promoCode) {
			const promocode: PromoCode = order?.promoCode;
			if (promocode.type === PromoCodeType.CHEAPEST_FREE_ARTICLE || promocode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
				let amount = 0;
				const mappedArray: string[] = promocode.value?.articles;
				order.orderedArticles.forEach(orderArticleGroup => {
					if (mappedArray.includes(orderArticleGroup.article._id)) {
						amount = amount + orderArticleGroup?.quantity;
					}
				});
				if (promocode?.value?.minQuantity) {
					let minValue = promocode?.value?.minQuantity;
					if (promocode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
						minValue = minValue + 1;
					}
					if (minValue > amount) {
						order = OrderUtils.removePromo(order);
					}
				}
			}
		}
		return order;
	}
	private async checkIfCanApplyPromoCode(order: Order) {
		if (
			order &&
			!order.promoCode &&
			this.customPromoCodeValue &&
			this.customPromoCodeValue?.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE &&
			this.order.orderedArticles.length > 0 &&
			!this.showCheckerDialog
		) {
			try {
				const isAvailablePromoCode = isAvailable(this.customPromoCodeValue.availability, this.order.type, this.order.preorder.type);
				console.log('checkIfCanApplyPromoCode', isAvailablePromoCode);
				if (!isAvailablePromoCode) {
					return;
				}
			} catch (e) {
				return;
			}
			let amount = 0;
			this.order.orderedArticles.forEach(it => {
				amount = amount + it.quantity;
			});
			if (amount < this.customPromoCodeValue?.value?.minQuantity) {
				return;
			}
			try {
				this.showCheckerDialog = true;
				const askAboutApplyPromoCode = await InfoModalComponent.show(this.modalCtrl, {
					title: this.translate.instant('ask_to_add_pizza.title'),
					info: this.translate.instant('ask_to_add_pizza.info'),
					mainButton: this.translate.instant('ask_to_add_pizza.yes'),
					closeButton: this.translate.instant('ask_to_add_pizza.no'),
				});
				this.showCheckerDialog = false;
				if (!askAboutApplyPromoCode) {
					this.customPromoCodeRemoved = true;
					return;
				}
			} catch (e) {
				this.showCheckerDialog = false;
			}
			try {
				const orderCopy = JSON.parse(JSON.stringify(order));
				orderCopy.promoCode = this.customPromoCodeValue;
				orderCopy.userUid = this.repository.customer.uid;
				orderCopy.orderAt = null;
				orderCopy.customerRedemptionPromoCode = this.customPromoCodeFor3Pizza;
				const result = await Api.applyPromoCode(orderCopy);
				const promoCode = this.customPromoCodeValue;
				if (result.data && promoCode.type === PromoCodeType.DEPENDENCY_FREEE_ARTICLE) {
					const foundFree = result.data.orderedArticles.find(it => it.isPromo && it.freeArticle);
					const foundInList =
						promoCode.value &&
						(promoCode.value?.freeArticle === foundFree?.article?._id ||
							promoCode.value?.freeArticle === foundFree?.article?.masterId);
					if (foundInList) {
						let foundArticleInVenue: Article = null;
						this.venue.articleCategories.forEach(cat => {
							let foundProduct = cat.articles.find(
								art => art._id === foundFree?.article?._id || art?.masterId === foundFree?.article?._id
							);
							if (foundProduct) {
								foundArticleInVenue = foundProduct;
							}
						});
						if (foundArticleInVenue) {
							foundFree.article = foundArticleInVenue;
							order.orderedArticles.push(foundFree);
						}
					}
					const orderValue = OrderUtils.applyPromo(this.translate, this.repository._venue, order, promoCode, this.analytics);
					this.repository.onOrderChange(orderValue);
				}
			} catch (e) {}
		}
	}
	async openCheckoutModal() {
		this.validate();
		if (!this.isValid || this.loading) {
			return;
		}
		this.loading = true;
		if (AppComponent.largeScreen) {
			this.openCheckout.emit();
		}
		const result = await CheckoutModalComponent.show(this.modalCtrl, this.analytics, this.order, this.tip);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;

		try {
			const resultData = this.checkBrowserData();
			this.order.clientMeta = resultData;
		} catch (e) {}

		this.tip = result.data.tip;
		this.repository.onOrderChange(this.order);
		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translate,
				this.order,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl
			);
		} catch (e) {
			console.log(JSON.parse(JSON.stringify(e)));
		}
	}

	validate() {
		if (!this.order || !this.venue || !this.order.preorder) {
			this.isValid = false;
			return;
		}
		const result = OrderUtils.validateOrder(this.venue, this.order);
		this.differenceToMvo = result.movDifference;
		const orderFSK = maxFskOfOrder(this.order);
		if (orderFSK > 0) {
			this.showAgeVefiried = true;
			if (!this.ageVerified) {
				this.isValid = false;
				return;
			}
		} else {
			this.showAgeVefiried = false;
		}

		this.isValid = result.valid;
	}
	amountOfPoints() {
		return OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
	}
	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (articleGroup.isHalfPizza) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));
				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}
	totalPrice() {
		if (this.venue && this.order.orderedArticles) {
			const foundArticleIndex = this.order.orderedArticles.findIndex(it => it.isHalfPizza);
			if (foundArticleIndex >= 0) {
				const foundArticle = this.venue.articleCategories
					.map(it => it.articles.find(ar => ar.tags.find(tag => tag.identifier == 'appliesMostExpensive')))
					.filter(it => !!it);

				if (foundArticle.length > 0) {
					let mappedOrder = JSON.parse(JSON.stringify(this.order)) as Order;
					mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
						if (it.isHalfPizza) {
							it.article = foundArticle[0];
						}
						return it;
					});
					const total = OrderUtils.orderTotalPrice(mappedOrder, true, true) + this.tip;
					this.totalPriceValue = numberToCurrency(total, this.order.currency);
					this.totalNumber = Math.round(total);
					return;
				}
			}
			const total = OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
			this.totalPriceValue = numberToCurrency(total, this.order.currency);
			this.totalNumber = Math.round(total);
		} else {
			const total = OrderUtils.orderTotalPrice(this.order, true, true) + this.tip;
			this.totalPriceValue = numberToCurrency(total, this.order.currency);
			this.totalNumber = Math.round(total);
		}
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.onOrderChange(order);
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		this.repository.onOrderChange(order);
	}

	onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error
		this.snackbarCtrl.open(error, null, { duration: 2000 });
		this.repository.onOrderChange(OrderUtils.removePromo(this.order));

		this.promoError = error;
	}

	async backToMenu() {
		await this.navigationService.menu();
	}

	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
				recommend: false,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data || response.data === '') {
			this.order.orderedArticles[index].note = response?.data;
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {
		console.log(event.detail.value);
	}
	login() {
		this.navigationService.signIn();
	}
	signUp() {
		this.navigationService.signUp();
	}
	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		console.log(articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')));
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
		// return articleGroup.article.tags.find(it => it.identifier == 'half_pizza');
	}
	identify(index, item) {
		return item?.group;
	}
	changeAgeVerification() {
		this.validate();
	}
	checkBrowserData() {
		try {
			const userAgent = navigator.userAgent;
			const platform = 'web';
			const browser = this.getBrowserInfo(userAgent);
			const osVersion = this.getOSVersion(userAgent);

			return {
				platform,
				appVersion: environment.version,
				osVersion,
				browser,
				device: userAgent,
			};
		} catch (e) {}
	}
	getBrowserInfo(userAgent: string): string {
		if (userAgent.includes('Chrome')) {
			return 'Chrome';
		} else if (userAgent.includes('Firefox')) {
			return 'Firefox';
		} else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
			return 'Safari';
		} else if (userAgent.includes('Edg')) {
			return 'Edge';
		}
		return 'Unknown';
	}

	getOSVersion(userAgent: string): string | null {
		const osMatches = [
			{ name: 'Windows', regex: /Windows NT ([\d.]+)/ },
			{ name: 'macOS', regex: /Mac OS X ([\d_]+)/ },
			{ name: 'iOS', regex: /iPhone OS ([\d_]+)/ },
			{ name: 'Android', regex: /Android ([\d.]+)/ },
		];

		for (const os of osMatches) {
			const match = userAgent.match(os.regex);
			if (match) {
				return `${os.name} ${match[1].replace(/_/g, '.')}`;
			}
		}

		return null;
	}
}
